import { Box, Image, IconButton, HStack, Center } from "@chakra-ui/react";
import { useState } from "react";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";

function ImageCarousel({ images }: any) {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Function to go to the next image
  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  // Function to go to the previous image
  const prevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };
  //width="100%"

  if (!images || images.length === 0) return null;
  return (
    <Box position="relative" maxWidth={"sm"} margin="auto">
      <Image
        src={`https://api.mazemap.com/api/images/${images[currentIndex].id}.original.jpeg`}
        alt={`Image ${currentIndex + 1}`}
        width="100%"
        height="auto"
        objectFit="cover"
        borderRadius={"2xl"}
      />
      {images.length > 1 ? (
        <HStack
          position="absolute"
          top="0%"
          width="100%"
          justify="space-between"
          height={"100%"}
        >
          <IconButton
            icon={<FaArrowLeft />}
            onClick={prevImage}
            aria-label="Previous Image"
            variant="ghost"
            size="sm"
            height={"100%"}
            bgColor={"rgba(52, 52, 52, 0.2)"}
            color="white"
            _hover={{ bgColor: "rgba(52, 52, 52, 0.7)" }}
            borderLeftRadius={"2xl"}
            borderRightRadius={"0"}
          />
          <IconButton
            icon={<FaArrowRight />}
            onClick={nextImage}
            aria-label="Next Image"
            variant="ghost"
            size="sm"
            height={"100%"}
            bgColor={"rgba(52, 52, 52, 0.2)"}
            color="white"
            _hover={{ bgColor: "rgba(52, 52, 52, 0.7)" }}
            borderRightRadius={"2xl"}
            borderLeftRadius={"0"}
          />
        </HStack>
      ) : null}
    </Box>
  );
}

export default ImageCarousel;
